/* eslint-disable */
<template>
    <div class="result-container">
        <v-navigation-drawer v-if="isGroup" width="300">
            <template v-slot:prepend>
                <div class="pa-8">
                    <v-btn
                        block
                        @click="this.$emit('upload')"
                        color="#3F51B5"
                    >
                        Laadi üles uus fail
                    </v-btn>
                </div>
            </template>
            <v-list>
                <v-list-item
                    link
                    title="Rühma kokkuvõte"
                    v-on:click="this.displayData = analysisResult.summary; activeListItem = -1"
                    :active="activeListItem === -1"
                    color="#3F51B5"
                    class="my-3"
                />

                <v-divider />

                <v-list-item>
                    <div class="text-overline">Individuaalsed analüüsid</div>
                </v-list-item>

                <v-list-item
                    v-for="(analysis, index) in analysisResult.analysis"
                    link
                    :title="analysis.studentName"
                    v-on:click="this.displayData = analysis; activeListItem = index"
                    v-bind:key="index"
                    :active="activeListItem === index"
                    class="py-3"
                    :style="{ color: analysis.error ? '#E01010' : '' }"
                />

            </v-list>
        </v-navigation-drawer>

        <v-container v-if="displayData">
            <v-container class="pt-8">

                <v-row class="pa-2" justify="space-between">
                    <div class="text-h4">Logide analüüs</div>
                    <v-btn
                        v-if="!isGroup"
                        @click="this.$emit('upload')"
                        color="#3F51B5"
                    >
                        Laadi üles uus fail
                    </v-btn>
                </v-row>

                <AnalysisIndividual v-if="displayData.queryEventGroups" :analysis="displayData"/>
                <AnalysisSummary v-else :analysis="displayData"/>

                <div v-if="displayData.errorCount !== 0">
                    <div class="text-h6 mt-6 mb-3">Vigade analüüs</div>

                    <v-card>
                        <v-container class="pa-8">
                            <h3 class="pb-6">Veatüüpide jaotus</h3>
                            <Bar :data="filteredData" :options="chartOptions"/>   
                        </v-container>

                        <v-container v-if="displayData.repeatedErrors.length !== 0" class="pa-8">
                            <h3 class="pb-6">Korduvad vead</h3>
                            <RepeatedErrorsPanel :errors="displayData.repeatedErrors"/>
                        </v-container>
                    </v-card>
                </div>

                <div v-if="displayData.logs && displayData.totalCount > 0">
                    <div class="text-h6 mt-6 mb-3">Kõik päringud</div>
                    <LogViewer :log="displayData.logs"/>
                </div>
                
                <div v-if="displayData.logsInteractingWithInimesed && displayData.interactionsWithInimesed > 0">
                    <div class="text-h6 mt-6 mb-3">Interaktsioonid tabeliga "Inimesed"</div>
                    <LogViewer :log="displayData.logsInteractingWithInimesed"/>
                </div>

            </v-container>
        </v-container>

        <div class="text-center" v-else>
            <v-progress-circular
                indeterminate
                color="primary"
            ></v-progress-circular>
        </div>

    </div>

</template>

<script>
import AnalysisSummary from "@/components/AnalysisSummary.vue";
import AnalysisIndividual from "@/components/AnalysisIndividual.vue";
import {Bar} from 'vue-chartjs'
import {Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale} from 'chart.js'
import RepeatedErrorsPanel from "@/components/RepeatedErrorsPanel.vue";
import LogViewer from "@/components/LogViewer.vue";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
    name: "AnalysisPage",
    components: {AnalysisIndividual, AnalysisSummary, Bar, RepeatedErrorsPanel, LogViewer},

    props: {
        analysisResult: Object,
    },

    data() {
        return {
            isGroup: Object.prototype.hasOwnProperty.call(this.analysisResult, 'summary'),
            displayData: this.analysisResult.summary ?? this.analysisResult,
            activeListItem: -1,
            chartOptions: {
                plugins: {
                    legend: {
                        display: false
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            autoSkip: false,
                        }
                    }, 
                    y: {
                        min: 0,
                        ticks: {
                            stepSize: 1,
                        }
                    }
                }
            }
        }
    },
    computed: {
        chartData() {
            return {
                labels: ['Süntaksivead', ['Defineerimata', 'väärtuse', 'kasutamine'], ['Kitsenduse', 'rikkumine'],
                    'Trükivead', ['Agregeeritud', 'funktsiooni', 'vead'], ['Topelt', 'defineerimine'],
                    ['Andmetüübi', 'mittevastavus'], 'Õigused', 'Kordus', 'Sõltuvus', 'Funktsioon',
                    ['Tabeli', 'definitsioon'], ['Puuduv', 'võtmesõna'], 'Struktuur',  'Muud vead'],
                datasets: [
                    {
                        title: 'Veatüüpide jaotus',
                        backgroundColor: ["#5EBD9B", "#F8DA62", '#104D83', "#F79F3D", "#72CAD8", '#E34F5B', '#A048A4', '#8B0000', '#FF4500', '#DA70D6', '#4682B4', '#32CD32', '#6A0DAD', '#FFD700', '#f66d9b'],
                        data: [this.displayData.syntaxErrorCount,
                            this.displayData.nonExistentValueCount,
                            this.displayData.constraintViolationCount,
                            this.displayData.typoCount,
                            this.displayData.aggregateErrorCount,
                            this.displayData.alreadyExistsErrorCount,
                            this.displayData.datatypeMismatchCount,
                            this.displayData.permissionErrorCount,
                            this.displayData.ambiguousErrorCount,
                            this.displayData.dependencyErrorCount,
                            this.displayData.functionErrorCount,
                            this.displayData.tableDefinitionErrorCount,
                            this.displayData.missingKeywordErrorCount,
                            this.displayData.structureErrorCount,
                            this.displayData.otherErrorCount]
                    }
                ],
            }
        },
        filteredData() {
            var chartData = this.chartData;
            return {
                labels: chartData.labels.filter((_, index) => this.chartData.datasets[0].data[index] > 0),
                datasets: chartData.datasets.map(dataset => ({
                    ...dataset,
                    backgroundColor: dataset.backgroundColor.filter((_, index) => dataset.data[index] > 0),
                    data: dataset.data.filter(value => value > 0)
                }))
            }
        }
    }
};
</script>

<style scoped>

.result-container {
    position: relative;
    align-items: center;
}

</style>